/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as PoolConfigContractJson } from "../PoolConfig.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace PoolConfigTypes {
  export type Fields = {
    config: types.Config;
  };

  export type State = ContractState<Fields>;

  export interface CallMethodTable {
    get: {
      params: Omit<CallContractParams<{}>, "args">;
      result: CallContractResult<types.Config>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    get: {
      params: Omit<SignExecuteContractMethodParams<{}>, "args">;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<
  PoolConfigInstance,
  PoolConfigTypes.Fields
> {
  encodeFields(fields: PoolConfigTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      types.AllStructs
    );
  }

  at(address: string): PoolConfigInstance {
    return new PoolConfigInstance(address);
  }

  tests = {
    get: async (
      params: Omit<
        TestContractParamsWithoutMaps<PoolConfigTypes.Fields, never>,
        "args"
      >
    ): Promise<TestContractResultWithoutMaps<types.Config>> => {
      return testMethod(this, "get", params, getContractByCodeHash);
    },
  };

  stateForTest(
    initFields: PoolConfigTypes.Fields,
    asset?: Asset,
    address?: string
  ) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const PoolConfig = new Factory(
  Contract.fromJson(
    PoolConfigContractJson,
    "",
    "aa0838a7a189126cf0627d909b65ba3cfc692813db3d5ccd950763a87d52a0d6",
    types.AllStructs
  )
);
registerContract(PoolConfig);

// Use this class to interact with the blockchain
export class PoolConfigInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<PoolConfigTypes.State> {
    return fetchContractState(PoolConfig, this);
  }

  view = {
    get: async (
      params?: PoolConfigTypes.CallMethodParams<"get">
    ): Promise<PoolConfigTypes.CallMethodResult<"get">> => {
      return callMethod(
        PoolConfig,
        this,
        "get",
        params === undefined ? {} : params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    get: async (
      params: PoolConfigTypes.SignExecuteMethodParams<"get">
    ): Promise<PoolConfigTypes.SignExecuteMethodResult<"get">> => {
      return signExecuteMethod(PoolConfig, this, "get", params);
    },
  };

  async multicall<Calls extends PoolConfigTypes.MultiCallParams>(
    calls: Calls
  ): Promise<PoolConfigTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends PoolConfigTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<PoolConfigTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | PoolConfigTypes.MultiCallParams
      | PoolConfigTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      PoolConfig,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
